module.exports = __webpack_public_path__ + "static/img/terminal2.ed96186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/terminal2.png
// module id = 0muI
// module chunks = 0